"use strict";

exports.__esModule = true;
exports.DashboardRenderer = DashboardRenderer;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
var _DeviceListContext = require("../Device/DeviceListContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function DashboardRenderer(props) {
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var style = props.style,
    children = props.children;
  if (!devices || !devices.length) {
    return /*#__PURE__*/_react["default"].createElement(_core.NonIdealState, {
      style: style,
      title: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "DashboardElement.noDevicesForSelectedFilters",
        defaultMessage: "No device(s) for selected filters"
      })
    });
  }
  return children;
}